import { APP_LANGUAGE } from '@Common/constants';
import { RootState } from '@Common/models/redux/store';
import { patterns, utmCampaignForExtension } from 'config/constants';
import { getCoreStore } from 'src/redux';
import German from 'public/i18n/de.json';

export const getTimeDifference = (startTime: number): number => {
  if (startTime > 0) {
    const seconds = (Date.now() - startTime) / 1000;
    return seconds;
  }
  return 0;
};

export const chunkSubstr = (str: string, size: number) => {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; i += 1, o += size) {
    chunks[i] = str.substr(o, size);
  }

  return chunks;
};
export interface IWordIndexes {
  indexes: number[];
  sentence: string;
}
export const getWordIndexes = (sentence: string): IWordIndexes => {
  const validWordRegex = patterns.validWordRegex;
  const words = sentence.split(/\s/);
  const wordIndexes: number[] = [];
  let len = 0;

  words.forEach((word) => {
    len += word.length;
    if (validWordRegex.test(word)) {
      wordIndexes.push(len);
    }
    len += 1;
  });

  return { indexes: wordIndexes, sentence };
};

/**
 * Method to check for the word limit and return index of last allowed character.
 */
export const inputWordLimitCheck = (sentenceOrIndexes: string | IWordIndexes, wordLimit: number): number => {
  let wordIndexes: IWordIndexes;
  let sentence: string;

  if (typeof sentenceOrIndexes === 'string') {
    sentence = sentenceOrIndexes;
    wordIndexes = getWordIndexes(sentenceOrIndexes);
  } else {
    sentence = sentenceOrIndexes.sentence;
    wordIndexes = sentenceOrIndexes;
  }

  if (wordLimit >= wordIndexes.indexes.length || wordLimit < 1) {
    return sentence.length;
  }

  return wordIndexes.indexes[wordLimit - 1];
};

export const getWordCount = (sentenceOrIndexes: string | IWordIndexes): number => {
  let wordIndexes: IWordIndexes;

  if (typeof sentenceOrIndexes === 'string') {
    wordIndexes = getWordIndexes(sentenceOrIndexes);
  } else {
    wordIndexes = sentenceOrIndexes;
  }
  return wordIndexes.indexes.length;
};
/*
// Test Cases for getWordCount
function testWordCount(sentence: string, words: number) {
  const count = getWordCount(sentence);
  if (words !== count) {
    console.error(`Test failed! expected ${words}, got ${count}`, sentence, getWordIndexes(sentence));
  }
}

const testCases: [string, number][] = [
  ['abc -- def ijk -- ', 3],
  ['abc def ijk', 3],
  ['  abc def ijk  ', 3],
  ['abc -- def ijk  ', 3],
  ['  abc def ijk  ', 3],
  ['   abc', 1],
  [' _ abc', 1],
  ['def ___ abc', 2],
  ['+_abc', 1],
  ['abc G-- def ijk  ', 4],
  ['abc g--', 2],
  ['abc g&-_-g', 2],
  ['+_+ abc +-+def+- -=', 2],
  ['+_+ abc +-+def+-_adc -=', 2],
  ["hello, what's up?", 3],
  ['ab ab-def fa', 3],
];

testCases.forEach(([sentence, length]) => {
  testWordCount(sentence, length);
});
*/

export const numberWithCommas = (num: string | number) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const getQueryParams = (position: string) =>
  `&utm_source=quillbot.com&utm_medium=referral&utm_campaign=${utmCampaignForExtension[position]}`;

export const removeNodesFromHTML = (html: string, selectors?: string[]) => {
  const temporalDivElement = document.createElement('div');
  temporalDivElement.innerHTML = html;
  if (selectors?.length) {
    temporalDivElement.querySelectorAll(selectors.join(', ')).forEach((node) => {
      node.parentNode?.removeChild(node);
    });
  }
  return {
    text: temporalDivElement.textContent || temporalDivElement.innerText || '',
    html: temporalDivElement.innerHTML || '',
  };
};

export const translateText = (text: string) => {
  const appLanguage = (getCoreStore()?.getState() as RootState).common.appLanguage;
  let translatedText = null;
  if (appLanguage === APP_LANGUAGE.German) translatedText = (German as any)[text];
  if (translatedText) return translatedText;
  return text;
};
